export enum ContactPreference {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}
